import { type FormEvent, type ReactNode, useState } from 'react';
import { ArrowRight } from 'lucide-react';

export type JumpProps = {
  total: number;
  onJump: (n: number) => void;
  placeholder?: string;
};

function parseTarget(value: string, total: number): number | null {
  const n = Number(value);
  if (!Number.isInteger(n)) return null;
  if (n < 1 || n > total) return null;
  return n;
}

// Inline-text styling. The input is the only "interactive" element with
// visual chrome — just a bottom underline that pulses brand-red on focus.
const INPUT_CLS =
  'w-20 border-0 border-b border-white/[0.08] bg-transparent px-1 py-0.5 text-sm tabular-nums text-text-primary focus:border-brand-red focus:outline-none [-moz-appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none';
const BTN_CLS =
  'text-text-tertiary transition-colors hover:text-brand-red disabled:opacity-30 disabled:hover:text-text-tertiary';

type InputProps = {
  raw: string;
  setRaw: (v: string) => void;
  jump: JumpProps;
};

function JumpInput(p: InputProps): ReactNode {
  return (
    <input
      type="number"
      inputMode="numeric"
      min={1}
      max={p.jump.total}
      placeholder={p.jump.placeholder ?? '1500'}
      value={p.raw}
      onChange={(e) => p.setRaw(e.target.value)}
      aria-label="Número de slot"
      className={INPUT_CLS}
    />
  );
}

function JumpSubmit({ enabled }: { enabled: boolean }): ReactNode {
  return (
    <button
      type="submit"
      disabled={!enabled}
      className={BTN_CLS}
      aria-label="Ir"
    >
      <ArrowRight size={14} />
    </button>
  );
}

export function FoundersJump(jump: JumpProps): ReactNode {
  const [raw, setRaw] = useState('');
  const target = parseTarget(raw, jump.total);
  const onSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    if (target !== null) jump.onJump(target);
  };
  return (
    <form
      onSubmit={onSubmit}
      className="flex items-baseline gap-sm text-sm text-text-secondary"
    >
      <span>Saltar al</span>
      <span className="text-text-tertiary">#</span>
      <JumpInput raw={raw} setRaw={setRaw} jump={jump} />
      <JumpSubmit enabled={target !== null} />
    </form>
  );
}
